module.exports = __webpack_public_path__ + "static/media/SmartService.ce49f48a.png";